/*
  VARELON AIR | MVEC -> Request a Charter bridge v1.0
  Theme DEVELOPMENT only until QA is complete.
  No data is sent on navigation or automatically. The Shopify contact form
  submits only when the visitor explicitly submits that existing form.
*/
(() => {
  'use strict';

  const SOURCE_KEY = 'va_mvec';
  const REF_KEY = 'va_mvec_ref';
  const MAX_NOTES = 1000;
  const labels = {
    en: ['Mission imported from MVEC', 'Please confirm the exact departure and arrival airports, then complete your contact details. No request has been sent yet.'],
    es: ['Misión importada desde MVEC', 'Confirme los aeropuertos exactos de salida y llegada y complete sus datos de contacto. Todavía no se ha enviado ninguna solicitud.'],
    fr: ['Mission importée depuis MVEC', 'Confirmez les aéroports exacts de départ et d’arrivée, puis renseignez vos coordonnées. Aucune demande n’a encore été envoyée.'],
    de: ['Mission aus MVEC übernommen', 'Bitte bestätigen Sie die genauen Abflug- und Zielflughäfen und ergänzen Sie Ihre Kontaktdaten. Es wurde noch keine Anfrage versendet.'],
    it: ['Missione importata da MVEC', 'Confermi gli aeroporti esatti di partenza e arrivo e completi i dati di contatto. Nessuna richiesta è stata ancora inviata.'],
    pt: ['Missão importada do MVEC', 'Confirme os aeroportos exatos de origem e destino e preencha seus dados de contato. Nenhuma solicitação foi enviada ainda.'],
    ja: ['MVECの分析内容を引き継ぎました', '正確な出発・到着空港をご確認のうえ、連絡先をご入力ください。リクエストはまだ送信されていません。']
  };

  function field(root, key) {
    return root.querySelector(`[data-mvec-id="${key}"]`);
  }

  function isoToday() {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  }

  function makeReference() {
    const now = new Date();
    const date = `${now.getUTCFullYear()}${String(now.getUTCMonth() + 1).padStart(2, '0')}${String(now.getUTCDate()).padStart(2, '0')}`;
    let suffix;
    try {
      const bytes = new Uint8Array(4);
      crypto.getRandomValues(bytes);
      suffix = [...bytes].map(v => v.toString(16).padStart(2, '0')).join('').toUpperCase();
    } catch {
      suffix = Math.random().toString(36).slice(2, 10).toUpperCase();
    }
    return `MVEC-${date}-${suffix}`;
  }

  // Intercept only MVEC's existing "Request a live charter quote" link.
  document.addEventListener('click', event => {
    const anchor = event.target.closest('.va-mvec [data-mvec-id="results"] .va-mvec__actions a[href]');
    if (!anchor || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;

    const root = anchor.closest('[data-varelon-mvec]');
    if (!root) return;
    const values = {};
    for (const key of ['origin', 'destination', 'date', 'passengers', 'trip']) {
      values[key] = String(field(root, key)?.value || '').trim();
    }
    const pax = Number(values.passengers);
    if (!values.origin || !values.destination || values.origin.toLowerCase() === values.destination.toLowerCase() ||
        !/^\d{4}-\d{2}-\d{2}$/.test(values.date) || values.date < isoToday() ||
        !Number.isInteger(pax) || pax < 1 || pax > 300) {
      event.preventDefault();
      field(root, 'recalc')?.click(); // invokes MVEC's existing localized validation
      return;
    }

     const url = new URL(
  'https://varelonair.com/pages/request-a-charter'
);
event.preventDefault();
    url.searchParams.set('from', values.origin);
    url.searchParams.set('to', values.destination);
    url.searchParams.set('date', values.date);
    url.searchParams.set('passengers', values.passengers);
    url.searchParams.set('trip_type', values.trip === 'round-trip' ? 'Round Trip' : 'One Way');
    url.searchParams.set(SOURCE_KEY, '1');
    url.searchParams.set(REF_KEY, makeReference());

        window.location.assign(url.toString());
  });

  function addHidden(form, name, value) {
    let el = [...form.querySelectorAll('input[type="hidden"]')].find(node => node.name === name);
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      form.appendChild(el);
    }
    el.value = value;
  }

  function initializeRequestForm() {
    const params = new URLSearchParams(window.location.search);
    if (params.get(SOURCE_KEY) !== '1') return;
    const form = document.querySelector('form#VarelonCharterForm');
    if (!form || form.dataset.mvecBridgeReady === 'true') return;
    form.dataset.mvecBridgeReady = 'true';
    if (form.querySelector('.va-message--success')) return;

    const refInUrl = params.get(REF_KEY) || '';
    const reference = /^MVEC-[0-9]{8}-[A-Z0-9]{4,12}$/.test(refInUrl) ? refInUrl : makeReference();
    const source = form.querySelector('input[name="contact[source]"]');
    if (source) source.value = 'MVEC - Mission Value Engine';

    addHidden(form, 'contact[mvec_reference]', reference);
    addHidden(form, 'contact[mvec_version]', '1.1.2');

    const language = String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    const copy = labels[language] || labels.en;
    const banner = document.createElement('div');
    banner.setAttribute('role', 'status');
    banner.className = 'va-mvec-handoff-notice';
    banner.style.cssText = 'background:rgba(200,169,107,.09);border:1px solid rgba(200,169,107,.42);border-radius:10px;padding:16px 18px;margin:0 0 30px;color:#f3f6f8;font-size:13px;line-height:1.6;';
    const heading = document.createElement('strong');
    heading.style.cssText = 'display:block;color:#c8a96b;font-size:13px;margin-bottom:5px;';
    heading.textContent = copy[0];
    const paragraph = document.createElement('div');
    paragraph.textContent = copy[1];
    const refLabel = document.createElement('div');
    refLabel.style.cssText = 'opacity:.7;font-size:11px;margin-top:5px;';
    refLabel.textContent = `MVEC · ${reference}`;
    banner.append(heading, paragraph, refLabel);
    form.insertBefore(banner, form.firstChild);

    // Shopify receives the marker only if the visitor submits the existing form.
    // Never overwrite or truncate the visitor's additional requirements.
    form.addEventListener('submit', () => {
      const notes = form.querySelector('textarea[name="contact[body]"]');
      if (!notes) return;
      const annotation = `[MVEC reference: ${reference}; illustrative scenario, not a flight quotation]`;
      if (notes.value.includes(annotation)) return;
      const combined = notes.value ? `${notes.value.trimEnd()}\n\n${annotation}` : annotation;
      if (combined.length > MAX_NOTES) return; // separate hidden reference remains available
      notes.value = combined;
      notes.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeRequestForm);
  else initializeRequestForm();
  document.addEventListener('shopify:section:load', initializeRequestForm);
})();
